import { eventBus } from '~/abstractions/event-bus';

export default (function (ctx, inject) {
    inject('eventBus', eventBus);
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/event-bus.js
// module id = ./src/plugins/event-bus.js
// module chunks = 34